// extracted by mini-css-extract-plugin
module.exports = {"question-card":"question-card__3098P"};